import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import AllOverdueTaskList from './components/otherTasks/AllOverdueTaskList';

const AllOverdueTasks = () => {
  return renderComponent(<AllOverdueTaskList />);
};

export default AllOverdueTasks;
